(() => {
  const root = document.querySelector('[data-h12-photo-preview]');
  const host = root?.closest('duepa-product-form');
  const canvas = root?.querySelector('[data-preview-canvas]');
  const status = root?.querySelector('[data-preview-status]');
  if (!root || !host || !canvas || !status) return;
  const context = canvas.getContext('2d');
  if (!context) return;
  const base = new Image();
  base.decoding = 'async';
  base.src = root.dataset.baseUrl;
  const thread = document.createElement('canvas');
  thread.width = thread.height = 8;
  const threadContext = thread.getContext('2d');
  if (threadContext) {
    threadContext.fillStyle = '#24422e';
    threadContext.fillRect(0, 0, 8, 8);
    threadContext.strokeStyle = 'rgba(106, 139, 91, .53)';
    threadContext.lineWidth = 1;
    for (let x = -8; x < 16; x += 3) {
      threadContext.beginPath();
      threadContext.moveTo(x, 8);
      threadContext.lineTo(x + 8, 0);
      threadContext.stroke();
    }
  }
  const optionId = 'duepa-b01-10731510169765-1';
  const controlForName = () => host.querySelector(`.easify.portal .po-option-root[data-option-id="${optionId}"] input[type="text"]`);
  const validName = control => {
    const name = control?.value.trim() || '';
    return control?.checkValidity() && /^[\p{L}][\p{L} '-]{1,11}$/u.test(name) ? name : '';
  };
  let scheduled = [];
  let reconcileTimer;
  let displayedName;
  let pageSuspended = false;
  let lastControl;
  let lastState;
  const cancelScheduled = () => {
    for (const timer of scheduled) clearTimeout(timer);
    scheduled = [];
    clearTimeout(reconcileTimer);
    reconcileTimer = undefined;
    displayedName = undefined;
  };
  const reconcile = () => {
    if (pageSuspended || document.hidden || !displayedName) return;
    if (canvas.hidden || root.dataset.previewVariantTitle?.trim().toLowerCase() !== 'beige'
      || controlForName() !== displayedName.control || validName(displayedName.control) !== displayedName.name) {
      draw();
      return;
    }
    if (!reconcileTimer) reconcileTimer = setTimeout(() => { reconcileTimer = undefined; reconcile(); }, 225);
  };
  const drawBase = () => {
    canvas.width = base.naturalWidth;
    canvas.height = base.naturalHeight;
    context.drawImage(base, 0, 0);
  };
  const draw = () => {
    if (pageSuspended) return;
    const variantMatches = root.dataset.previewVariantTitle?.trim().toLowerCase() === 'beige';
    if (!variantMatches) {
      cancelScheduled();
      lastState = '';
      canvas.hidden = true;
      canvas.removeAttribute('aria-label');
      status.textContent = `An illustrative name preview is not available for ${root.dataset.previewVariantTitle || 'this'} crown. The product gallery shows the authentic six-color reference; the selected color and name fields still control your order.`;
      return;
    }
    if (!base.complete || !base.naturalWidth) return;
    const control = controlForName();
    const name = validName(control);
    const state = name || '(no valid name)';
    if (lastControl === control && lastState === state) return;
    cancelScheduled();
    lastControl = control;
    lastState = state;
    canvas.hidden = false;
    drawBase();
    canvas.setAttribute('aria-label', 'Clean Beige birthday crown photograph awaiting a valid name');
    if (!name) {
      status.textContent = 'Enter a valid 2–12 character name in the real personalization field to see placement on the Beige crown.';
      return;
    }
    // Easify can silently reset a newly mounted field after input handlers
    // run. Show the clean base until the real control retains this value.
    status.textContent = 'Checking the name in the real personalization field before showing its placement.';
    if (document.hidden) return;
    scheduled.push(setTimeout(() => {
      if (controlForName() !== control || validName(control) !== name) { draw(); return; }
      drawBase();
      const width = canvas.width, height = canvas.height;
      context.save();
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.font = `700 ${Math.round(width * .09)}px Georgia, serif`;
      context.lineJoin = 'round';
      context.shadowColor = 'rgba(32, 28, 18, .48)';
      context.shadowBlur = Math.max(1, width * .002);
      context.shadowOffsetX = Math.max(1, width * .001);
      context.shadowOffsetY = Math.max(2, width * .002);
      context.lineWidth = Math.max(1, width * .002);
      context.strokeStyle = '#1b3024';
      context.fillStyle = context.createPattern(thread, 'repeat') || '#254530';
      context.strokeText(name.toLocaleUpperCase(), width * .5, height * .605, width * .45);
      context.fillText(name.toLocaleUpperCase(), width * .5, height * .605, width * .45);
      context.restore();
      status.textContent = `Illustrative embroidered-name placement for ${name} on the Beige crown. Confirm the name and crown color in the fields above.`;
      canvas.setAttribute('aria-label', `Illustrative Beige birthday crown photograph with the name ${name}`);
      displayedName = {control, name};
      reconcile();
    }, 80));
  };
  base.addEventListener('load', draw);
  base.addEventListener('error', () => { canvas.hidden = true; status.textContent = 'Preview photograph could not load. The personalization fields remain available above.'; });
  host.addEventListener('input', draw);
  host.addEventListener('change', draw);
  host.addEventListener('variant:change', draw);
  const portalObserver = new MutationObserver(draw);
  let observedPortal;
  const watchPortal = () => {
    const portal = host.querySelector('.easify.portal');
    if (!portal || portal === observedPortal) return;
    portalObserver.disconnect();
    portalObserver.observe(portal, {childList: true, characterData: true, subtree: true});
    observedPortal = portal;
    draw();
  };
  const mountObserver = new MutationObserver(watchPortal);
  mountObserver.observe(host, {childList: true, subtree: true});
  watchPortal();
  window.addEventListener('pagehide', () => {pageSuspended = true; cancelScheduled(); lastState = null; portalObserver.disconnect(); mountObserver.disconnect();});
  window.addEventListener('pageshow', event => {
    if (!event.persisted && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    if (event.persisted) {
      pageSuspended = false;
      lastState = null;
      observedPortal = null;
      mountObserver.observe(host, {childList: true, subtree: true});
      watchPortal();
    }
    draw();
    // Browser form restoration can settle after pageshow without an input event.
    scheduled.push(setTimeout(draw, 150));
  });
  window.addEventListener('focus', () => {if (pageSuspended) return; if (displayedName) reconcile(); else if (!document.hidden) draw();});
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {cancelScheduled(); lastState = null;}
    else if (!pageSuspended) draw();
  });
  draw();
})();
